module.exports = require('./dist/InfiniteScroll')



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-infinite-scroller/index.js
// module id = 315
// module chunks = 0